// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"f3241a5b","358":"8333e26c","405":"c49157b7","478":"f956444f","620":"ea7494ad","642":"6b82f999","670":"8b1cc9bc","686":"597569f7","703":"baf5514d","791":"47d48df8","827":"108b2284"}[chunkId] + ".chunk.js";
};